import { render, staticRenderFns } from "./PoisAddView.vue?vue&type=template&id=16a3a9ae&scoped=true&"
import script from "./PoisAddView.vue?vue&type=script&lang=js&"
export * from "./PoisAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3a9ae",
  null
  
)

export default component.exports